








import { Vue, Component, Prop } from 'vue-property-decorator';
import FindIcon from '../icon/FindIcon.vue';
import { getTeacherSuffixInSession } from '../../utils/building_trans';

@Component({ components: { FindIcon } })
export default class FindTeacherButton extends Vue {
  @Prop({ default: '' })
  title!: string;

  get teacherSuffix() {
    return getTeacherSuffixInSession();
  }
}
